/**
 * Clamps a number in a given range.
 * @param val {number} Value to clamp
 * @param min {number} Max Rage Value
 * @param max {number} Min Rage Value
 */
export const clamp = (val: number, min: number, max: number) =>
  Math.min(Math.max(min, val), max);
